import { Injectable } from '@angular/core';
import { ContractColumn } from '../models/maintenance-costing.model';
import {
  DEFAULT_MAINTENANCE_CONTRACT_COLUMNS,
  MAINTENANCE_CONTRACT_COLUMNS
} from '../constants/maintenance-contract-columns.constants';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceContractColumnService {
  private readonly storageKey: string = 'v2.maintenanceContractColumns';

  getSelectedColumns(): string[] {
    return this.getStoredColumns() ?? [...DEFAULT_MAINTENANCE_CONTRACT_COLUMNS];
  }

  storeSelectedColumns(columns: string[]): void {
    localStorage.setItem(this.storageKey, JSON.stringify(columns));
  }

  clearSelectedColumns(): void {
    localStorage.removeItem(this.storageKey);
  }

  resolveColumns(selectedColumns: string[] | null | undefined): ContractColumn[] {
    const selected = selectedColumns?.length ? selectedColumns : this.getSelectedColumns();

    return [
      ...MAINTENANCE_CONTRACT_COLUMNS.filter(column => selected.includes(column.value))
    ];
  }

  private getStoredColumns(): string[] | null {
    const stored = localStorage.getItem(this.storageKey);

    if (!stored) {
      return null;
    }

    try {
      const parsed = JSON.parse(stored);
      const columns: string[] = Array.isArray(parsed)
        ? parsed.filter((value: unknown) => MAINTENANCE_CONTRACT_COLUMNS.some(column => column.value === value))
        : [];

      return columns.length ? columns : null;
    } catch {
      return null;
    }
  }
}